import React, { Component } from "react";
import PropTypes from "prop-types";
import Dialog from "./../../../../UiComponents/Dialog";
import getLabel from './../../../../../utils/labels';
import styles from "./messageSelector.module.scss";
import MessageOptionItem from "../messageOptionItem";

class MessageSelector extends Component {
	constructor(props) {
		super(props);
		this.state = {
			id: props.id,
			selectedOption: null,
			showWarningMessage: false
		};
	}

	onOptionClick = id => {
		this.setState({
			selectedOption: id,
			showWarningMessage: false
		});

		if (this.props.tutorial.isRunning) {
			this.goToNextTutorialStep();
		}
	};

	goToNextTutorialStep = () => {
		this.props.updateStepNumber(this.props.tutorial.stepIndex + 1);
	};

	clearSelectedOption = () => {
		this.setState({
			selectedOption: undefined
		});
		this.props.handleClose();
	};

	getWarningMessageText = showWarningMessage => {
		if (showWarningMessage) {
			return getLabel('label_select_option_text')
		} else {
			return null
		}
	}

	updateData = () => {
		let value = this.state.selectedOption
		if (typeof value === 'number' && isFinite(value)) {
			//updateing parent compoennt
			this.setState({
				showWarningMessage: false
			})
			let optionArray = [];
			optionArray.push(this.state.selectedOption);
			this.props.updateBody(this.state.id, optionArray);
			this.props.handleClose();
		} else {
			this.setState({
				showWarningMessage: true
			})
		}

		if (this.props.tutorial.isRunning) {
			this.goToNextTutorialStep();
		}
	};

	goToNextTutorialStep = () => {
		this.props.updateStepNumber(this.props.tutorial.stepIndex + 1);
	};

	render() {
		const { options } = this.props;

		const getMessageList = () =>
			options.map((option, index) => {
				return (
					<MessageOptionItem
						{...option}
						key={option.id}
						index={index}
						selectedOption={this.state.selectedOption}
						isHighlighted={this.state.selectedOption === option.id}
						onClick={this.onOptionClick}
					/>
				);
			});

		return (
			<Dialog
				title={getLabel('label_message_selector_text')}
				overlayClassName={styles.dialog}
				containerClassName={styles["overlay-container"]}
				onClose={this.handleClose}
				warningMessage={this.getWarningMessageText(this.state.showWarningMessage)}
				buttons={[
					{
						text: getLabel('label_cancel_button'),
						onClick: () => this.clearSelectedOption(),
						className: styles["cancel-button"]
					},
					{
						text: getLabel('label_add_button'),
						onClick: () => this.updateData(),
						className: styles["ok-button"],
						id: "tutorial-add-option"
					}
				]}
				hideOverflow={true}
				contentStyle={{ height: "calc(100% - 90px)" }}
			>
				<div className={styles["message-list"]}>{getMessageList()}</div>
			</Dialog>
		);
	}
}

MessageSelector.propTypes = {
	options: PropTypes.array,
	handleClose: PropTypes.func,
	updateBody: PropTypes.func,
	id: PropTypes.number
};

MessageSelector.defaultProps = {};

export default MessageSelector;



// WEBPACK FOOTER //
// /src/components/mailThread/compose/messageHandler/messageSelector/MessageSelector.js